import * as React from 'react';
import { ISelectActions } from '../types';

interface IProps {
  open: boolean;
  actions: ISelectActions;
  multiple?: boolean;
}

export const handleKeyboardEvent = (e: React.KeyboardEvent, props: IProps) => {
  switch (e.nativeEvent.key) {
    case ' ':
      return handleSpace(e, props);
    case 'Tab':
      return handleTab(e, props);
    case 'Enter':
      return handleEnter(e, props);
    case 'Escape':
      return handleEscape(e, props);
    case 'ArrowUp':
    case 'ArrowDown':
      return handleVerticalArrow(e, props);
  }
};

function handleSpace(e: React.KeyboardEvent, options: IProps) {
  e.preventDefault();

  if (options.open) {
    if (options.multiple) {
      options.actions.toggleFocusedOptionState();
    } else {
      options.actions.toggleFocusedOptionState();
      options.actions.closeDropdown();
    }
  } else {
    options.actions.openDropdown();
  }
}

function handleEnter(e: React.KeyboardEvent, options: IProps) {
  if (options.open) {
    e.preventDefault();

    if (options.multiple) {
      options.actions.toggleFocusedOptionState();
    } else {
      options.actions.toggleFocusedOptionState();
      options.actions.closeDropdown();
    }
  }
}

function handleEscape(e: React.KeyboardEvent, options: IProps) {
  if (options.open) {
    options.actions.closeDropdown();
  }
}

function handleVerticalArrow(e: React.KeyboardEvent, options: IProps) {
  e.preventDefault();

  if (options.open) {
    const delta = e.nativeEvent.key === 'ArrowUp' ? -1 : 1;

    options.actions.moveFocus(delta);
  } else {
    options.actions.openDropdown();
  }
}

function handleTab(e: React.KeyboardEvent, options: IProps) {
  if (options.open) {
    e.preventDefault();

    options.actions.closeDropdown();
  }
}
